import {
  askHeidiBarWidthAtom,
  sessionsBarWidthAtom,
} from '@/atoms/persistedPreferencesAtoms';
import { useAtomValue, useSetAtom } from 'jotai';

// SessionsBar width constants (percentage)
export const SESSIONS_BAR_WIDTH = {
  DEFAULT: 10,
  MIN: 10,
  MAX: 50,
} as const;

// Ask Heidi width constants (percentage)
export const ASK_HEIDI_BAR_WIDTH = {
  DEFAULT: 40,
  MIN: 25,
  MAX: 50,
} as const;

export const useSessionsBarWidth = () => {
  const storedWidth = useAtomValue(sessionsBarWidthAtom);
  const writeSessionsBarWidth = useSetAtom(sessionsBarWidthAtom);

  const setSessionsBarWidth = (width: number) => {
    if (width === 0) {
      return;
    }
    const clampedWidth = Math.max(width, SESSIONS_BAR_WIDTH.MIN);
    writeSessionsBarWidth(clampedWidth);
  };

  return {
    width: storedWidth ?? SESSIONS_BAR_WIDTH.DEFAULT,
    setWidth: setSessionsBarWidth,
  };
};

export const useAskHeidiBarWidth = () => {
  const storedWidth = useAtomValue(askHeidiBarWidthAtom);
  const writeAskHeidiBarWidth = useSetAtom(askHeidiBarWidthAtom);

  const setAskHeidiBarWidth = (width: number) => {
    if (width === 0) {
      return;
    }
    const clampedWidth = Math.max(width, ASK_HEIDI_BAR_WIDTH.MIN);
    writeAskHeidiBarWidth(clampedWidth);
  };

  return {
    width: storedWidth ?? ASK_HEIDI_BAR_WIDTH.DEFAULT,
    setWidth: setAskHeidiBarWidth,
  };
};
